import React, { Component } from "react";
import { Row, Col } from "design-react-kit";

import "./CorrispondenzaTitoli.scss";

export class CorrispondenzaTitoli extends Component {
  render() {
    return (
      <section className="programmes">
        <Row>
          <Col xs={12}>
            <div className="swiper-slide">
              <div className="programme-card">
                <a href={this.props.href} className="programme-card__link">
                  <div className="programme-card__body corrispondenza-titoli__body text-center">
                    <h4>Corrispondenza Titoli di studio e Classi di Concorso</h4>
                    <h6>
                      Vuoi sapere a quale insegnamento puoi accedere con il tuo titolo di
                      studi?
                    </h6>
                    <span className="btn btn-primary bg-dark corrispondenza-titoli__cta">
                      Scoprilo adesso
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </section>
    );
  }
}

export default CorrispondenzaTitoli;
